import { Trans } from '@lingui/react/macro';
import type { ComponentProps } from 'react';

import WarningIcon from '@/assets/svg/bxs-warning.svg?react';
import { useSelectContext } from '@/components/Form/pickers/primitives/select/SelectContext';
import { Spinner } from '@/components/loaders';
import { cn } from '@/lib/utils';

export type SelectStatusProps = ComponentProps<'div'>;

const SelectStatus = ({ className, ...props }: SelectStatusProps) => {
  const { error, isLoading } = useSelectContext();

  const getStatus = () => {
    if (isLoading) {
      return (
        <>
          <Spinner size="xs" variant="spoke" />
          <Trans>Searching...</Trans>
        </>
      );
    }

    if (error) {
      return (
        <>
          <WarningIcon className="size-5" />
          <Trans>Unable to load items</Trans>
        </>
      );
    }

    return null;
  };

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className={cn(
        'flex items-center gap-2 px-3 py-2 text-sm text-gray-500 italic empty:hidden',
        className,
      )}
      {...props}
    >
      {getStatus()}
    </div>
  );
};

export default SelectStatus;
